import { render } from "./DevolucionModal.vue?vue&type=template&id=9a67abfe"
import script from "./DevolucionModal.vue?vue&type=script&lang=js"
export * from "./DevolucionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__